module.exports = __webpack_public_path__ + "static/media/icon_add.a9f26692.svg";